import type { ReportStatus } from '@act/shared/data-transfer-objects';
import { Chip } from '@mui/material';
import { REPORT_STATUS_LABELS } from '../utils/reportDisplay.util';

export interface ReportStatusBadgeProps {
  status: ReportStatus;
}

/**
 * Compact status chip for archived reports in list and builder headers.
 * @param props - Report lifecycle status.
 */
const ReportStatusBadge = ({ status }: ReportStatusBadgeProps) => {
  if (status !== 'archived') {
    return null;
  }

  return (
    <Chip
      size="small"
      label={REPORT_STATUS_LABELS[status]}
      color="default"
      variant="outlined"
    />
  );
};

export default ReportStatusBadge;
